import { Grid3x3, Target, BarChart3, Briefcase, FileText, Calendar, Users, Bot, Zap, TrendingUp, Award, PieChart, Building, MessageSquare, BookOpen, Package, Mail, Pen, Sparkles, ListChecks, Cloud, DollarSign, Mountain, Scale, Library, Shield, Eye, Book, Receipt, Music, Timer, CheckSquare, GraduationCap, Coins, ShoppingCart } from 'lucide-react';
export const ALL_APPS = [
    {
        id: 'missions',
        name: 'Missions',
        description: 'Mission control & task tracking',
        icon: Target,
        path: '/app/missions',
        color: '#8B5CF6',
        available: true
    },
    {
        id: 'teams',
        name: 'Teams',
        description: 'Team collaboration & chat',
        icon: Users,
        path: '/app/teams',
        color: '#14B8A6',
        available: true
    },
    {
        id: 'goals',
        name: 'Goals',
        description: 'OKR & goal tracking',
        icon: Award,
        path: '/app/goals',
        color: '#EF4444',
        available: true
    },
    {
        id: 'portfolios',
        name: 'Portfolios',
        description: 'Project portfolio management',
        icon: Briefcase,
        path: '/app/portfolios',
        color: '#F59E0B',
        available: true
    },
    {
        id: 'projects',
        name: 'Projects',
        description: 'Project management & tracking',
        icon: Grid3x3,
        path: '/app/projects',
        color: '#3B82F6',
        available: true
    },
    {
        id: 'workflow',
        name: 'Workflows',
        description: 'Process automation',
        icon: Zap,
        path: '/app/workflows',
        color: '#F97316',
        available: true
    },
    {
        id: 'agents',
        name: 'AI Agents',
        description: 'Autonomous AI assistants',
        icon: Bot,
        path: '/app/agents',
        color: '#6366F1',
        available: true
    },
    {
        id: 'tide',
        name: 'Tide',
        description: 'AI Marketing - Plans campaigns, creates content, learns your brand voice, and automates publishing',
        icon: Sparkles,
        path: '/app/tide',
        color: '#06B6D4',
        available: true
    },
    {
        id: 'sales',
        name: 'Sales CRM',
        description: 'AI-powered relationship & sales management',
        icon: DollarSign,
        path: '/app/sales',
        color: '#F59E0B',
        available: true
    },
    {
        id: 'accounts',
        name: 'Accounts',
        description: 'Double-entry accounting & finance management',
        icon: Receipt,
        path: '/app/accounts',
        color: '#10B981',
        available: true
    },
    {
        id: 'check-manager',
        name: 'Check Manager',
        description: 'Electronic check management & processing',
        icon: FileText,
        path: '/app/check-manager',
        color: '#06B6D4',
        available: true
    },
    {
        id: 'calendar',
        name: 'Calendar',
        description: 'Schedule & time management',
        icon: Calendar,
        path: '/app/calendar',
        color: '#EC4899',
        available: true
    },
    {
        id: 'sound-studio',
        name: 'Sound Studio',
        description: 'Ambient soundscapes for focus & flow',
        icon: Music,
        path: '/app/sound-studio',
        color: '#3B82F6',
        available: true
    },
    {
        id: 'mauna',
        name: 'Mauna Focus',
        description: 'Pomodoro timer with breaths & steps',
        icon: Mountain,
        path: '/app/mauna',
        color: '#EC4899',
        available: true
    },
    {
        id: 'thirtythirty',
        name: '30/30',
        description: 'Task queue timer with focus management',
        icon: Timer,
        path: '/app/thirtythirty',
        color: '#F59E0B',
        available: true
    },
    {
        id: 'vision',
        name: 'Vision Board',
        description: 'Hierarchical goal planning & tracking',
        icon: Eye,
        path: '/app/vision',
        color: '#8B5CF6',
        available: true
    },
    {
        id: 'bones',
        name: 'Bones',
        description: 'Risk management & mitigation',
        icon: Shield,
        path: '/app/bones',
        color: '#DC2626',
        available: true
    },
    {
        id: 'habits',
        name: 'Habits',
        description: 'Habit tracking & timeline view',
        icon: ListChecks,
        path: '/app/habits',
        color: '#10B981',
        available: true
    },
    {
        id: 'clouds',
        name: 'Clouds',
        description: 'Emotional processing & reflection',
        icon: Cloud,
        path: '/app/clouds',
        color: '#06B6D4',
        available: true
    },
    {
        id: 'email',
        name: 'Email',
        description: 'Email management',
        icon: Mail,
        path: '/app/email',
        color: '#3B82F6',
        available: true
    },
    {
        id: 'ink',
        name: 'Ink',
        description: 'Document editor & Typst publishing',
        icon: Pen,
        path: '/app/ink',
        color: '#8B5CF6',
        available: true
    },
    {
        id: 'reader',
        name: 'Reader',
        description: 'EPUB & Markdown reader with fullscreen mode',
        icon: Book,
        path: '/app/reader',
        color: '#F59E0B',
        available: true
    },
    {
        id: 'legal-documents',
        name: 'Legal Docs',
        description: 'Legal document management & templates',
        icon: Scale,
        path: '/app/legal-documents',
        color: '#DC2626',
        available: true
    },
    {
        id: 'document-management',
        name: 'Document Review',
        description: 'Investor document verification & approval',
        icon: CheckSquare,
        path: '/app/document-management',
        color: '#8B5CF6',
        available: true
    },
    {
        id: 'template-library',
        name: 'Templates',
        description: 'Document template library',
        icon: Library,
        path: '/app/template-library',
        color: '#7C3AED',
        available: true
    },
    {
        id: 'chat',
        name: 'Chat',
        description: 'Team messaging',
        icon: MessageSquare,
        path: '/app/chat',
        color: '#22C55E',
        available: true
    },
    {
        id: 'knowledge',
        name: 'Knowledge Base',
        description: 'Documentation & wikis',
        icon: BookOpen,
        path: '/app/knowledge',
        color: '#A855F7',
        available: true
    },
    {
        id: 'analytics',
        name: 'Analytics',
        description: 'Advanced analytics',
        icon: TrendingUp,
        path: '/app/analytics',
        color: '#06B6D4',
        available: true
    },
    {
        id: 'reports',
        name: 'Reports',
        description: 'Custom reporting',
        icon: PieChart,
        path: '/app/reports',
        color: '#84CC16',
        available: true
    },
    {
        id: 'resources',
        name: 'Resources',
        description: 'Asset management',
        icon: Package,
        path: '/app/resources',
        color: '#F43F5E',
        available: true
    },
    {
        id: 'organization',
        name: 'Organization',
        description: 'Organization settings',
        icon: Building,
        path: '/app/organization/settings',
        color: '#64748B',
        available: true
    },
    {
        id: 'blue',
        name: 'Blue',
        description: 'Work management & collaboration platform',
        icon: Grid3x3,
        path: '/app/my-office',
        color: 'var(--cyan-bright)',
        available: true
    },
    {
        id: 'insights',
        name: 'Insights',
        description: 'Analytics & reporting dashboard',
        icon: BarChart3,
        path: '/app/insights',
        color: '#10B981',
        available: true
    },
    {
        id: 'training',
        name: 'Training',
        description: 'Staff training on business processes by department & position',
        icon: GraduationCap,
        path: '/app/training',
        color: '#7C3AED',
        available: true
    },
    {
        id: 'feedback',
        name: 'Feedback',
        description: 'Feature requests, bug reports, and community feedback',
        icon: MessageSquare,
        path: '/app/feedback',
        color: '#EC4899',
        available: true
    },
    {
        id: 'token-hub',
        name: 'Token Hub',
        description: 'Create, deploy, and manage blockchain tokens with white glove service',
        icon: Coins,
        path: '/app/token-hub',
        color: '#F59E0B',
        available: true
    },
    {
        id: 'ecommerce',
        name: 'E-commerce',
        description: 'Multi-store e-commerce management with board integration',
        icon: ShoppingCart,
        path: '/app/ecommerce',
        color: '#10B981',
        available: true
    }
];
